import * as React from 'react';
import spinnerIcon from '../../icons/spinner.svg';
export default function Spinner(_a) {
    var style = _a.style;
    return (React.createElement("svg", { width: '128', height: '128', style: style || { marginTop: '100px' } },
        React.createElement("image", { xlinkHref: spinnerIcon, width: '128', height: '128' })));
}
